export enum HostApplicationName {
  UnityMX = 'unity-mx',
  UnityFC = 'unity-fc',
  OnRoad = 'on-road',
  VisionPro = 'vision-pro',
  VisionAI = 'vision-ai',
  TrackAndTrace = 'track-and-trace',
  FleetView = 'fleet-view'
}

/** Platform a host application belongs to, as far as the Insights filters are concerned. */
export type HostPlatform = 'on-road' | 'on-site';

export interface HostPageNavigatedPayload {
    platformShown: HostApplicationName;
}

/**
 * Base context always provided by the embedded host (embedded.aura.unityaiot.com).
 * Contains user identity, localisation, and page-origin fields common to all platforms.
 */
export interface BaseAppContext {
  context_host: HostApplicationName;
  context_platform: HostApplicationName;
  context_platform_page_url: string;
  user_id: string;
  user_email: string;
  user_first_name: string;
  user_last_name: string;
  /** BCP-47 language tag, e.g. "fr-CA" */
  language: string;
  /** BCP-47 language tag (region-neutral), e.g. "fr" */
  locale: string;
  units_of_measure: 'metric' | 'imperial-uk' | 'imperial-us';
  /** IANA timezone identifier, e.g. "Europe/Tallinn" */
  timezone: string;
}

/** Organisation and environment fields supplied by the On-Road platform (on_road.unityaiot.com). */
export interface OnRoadPlatformExtension {
  /** Deployment environment, e.g. "uk" | "za" | "ent" | "uae" */
  environment: string;
  org_id: string;
  org_name: string;
  user_id: string;
  [key: string]: any;
}

/** Facility and user fields supplied by the On-Site platform (on_site.unityaiot.com). */
export interface OnSitePlatformExtension {
  facility_id: string;
  facility_name: string;
  user_id: string;
  [key: string]: any;
}

/** Organisation and environment fields supplied by the FC platform (fc.fleetcomplete.com). */
export interface FcPlatformExtension {
  /** Deployment environment, e.g. "eu" | "us" */
  environment: string;
  org_id: string;
  org_name: string;
  [key: string]: any;
}

/** Organisation and environment fields supplied by the MX platform. */
export interface MxPlatformExtension {
  environment: string;
  [key: string]: any;
}

/**
 * Full context object received from the host application.
 * The embedded aura section is always present; FC and MX sections are optional
 * and only included when the relevant platform is active.
 */
export interface HostAppContext {
  'embedded.aura.unityaiot.com': BaseAppContext;
  'on_road.unityaiot.com'?: OnRoadPlatformExtension | undefined;
  'on_site.unityaiot.com'?: OnSitePlatformExtension | undefined;
  'fc.fleetcomplete.com'?: FcPlatformExtension | undefined;
  'mx.unityaiot.com'?: MxPlatformExtension | undefined;
}